<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.planCode" clearable placeholder="计划编号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.planState" clearable placeholder="状态" style="width:110px">
        <el-option label="草稿" value="00" />
        <el-option label="已下发" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="planCode" label="计划编号" min-width="140" show-overflow-tooltip />
      <el-table-column prop="planName" label="计划名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="orderCode" label="工单号" min-width="140" show-overflow-tooltip />
      <el-table-column prop="productNumber" label="产品编码" width="120" />
      <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="planDate" label="计划日期" width="110" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.planState === '01' ? 'success' : 'info'">
            {{ row.planState === '01' ? '已下发' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewRow(row.planId)">查看</el-button>
          <el-button type="text" :disabled="row.planState !== '00'" @click="dispatchRow(row.planId)">下发</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.planState !== '00'" @click="deleteRow(row.planId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="'派工单 ' + (detail.planCode || '')" :visible.sync="detailVisible" width="980px" top="4vh">
      <div id="work-plan-print" class="wp-print">
        <h2 class="wp-title">生产作业派工单</h2>
        <table class="wp-meta">
          <tr>
            <td><b>计划编号：</b>{{ detail.planCode }}</td>
            <td><b>计划名称：</b>{{ detail.planName }}</td>
            <td><b>计划日期：</b>{{ fmtDate(detail.planDate) }}</td>
            <td><b>状态：</b>{{ detail.planState === '01' ? '已下发' : '草稿' }}</td>
          </tr>
          <tr>
            <td><b>工单号：</b>{{ detail.orderCode }}</td>
            <td colspan="2"><b>产品：</b>{{ detail.productNumber }} / {{ detail.productName }}</td>
            <td><b>产线：</b>{{ detail.productionLineName || '-' }}</td>
          </tr>
          <tr>
            <td><b>工单计划量：</b>{{ detail.orderPlannedQty }}</td>
            <td><b>计划开始：</b>{{ fmtDateTime(detail.orderPlanDateFrom) }}</td>
            <td><b>计划结束：</b>{{ fmtDateTime(detail.orderPlanDateTo) }}</td>
            <td></td>
          </tr>
        </table>
        <table class="wp-lines">
          <thead>
            <tr>
              <th style="width:40px">序号</th>
              <th style="width:110px">任务号</th>
              <th style="width:70px">工序号</th>
              <th>工序名称</th>
              <th style="width:80px">计划量</th>
              <th style="width:120px">计划开始</th>
              <th style="width:120px">计划结束</th>
              <th style="width:100px">产线</th>
              <th style="width:80px">操作工</th>
              <th style="width:80px">签字</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in (detail.lineList || [])" :key="row.lineId || idx">
              <td class="c">{{ idx + 1 }}</td>
              <td>{{ row.taskCode }}</td>
              <td class="c">{{ row.operationNumber }}</td>
              <td>{{ row.operationName }}</td>
              <td class="r">{{ row.plannedQty }}</td>
              <td class="c">{{ fmtDateTime(row.planStart) }}</td>
              <td class="c">{{ fmtDateTime(row.planEnd) }}</td>
              <td>{{ row.productionLineName || detail.productionLineName || '' }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-if="!(detail.lineList && detail.lineList.length)">
              <td colspan="10" class="c">无明细</td>
            </tr>
          </tbody>
        </table>
        <p v-if="detail.remark" class="wp-remark"><b>备注：</b>{{ detail.remark }}</p>
        <div class="wp-sign">
          <span>调度：____________</span>
          <span>班组长：____________</span>
          <span>日期：____________</span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button v-if="detail.planState === '00'" type="warning" @click="dispatchFromDetail">下发</el-button>
        <el-button type="primary" @click="doPrint">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listWorkPlan, getWorkPlan, deleteWorkPlan, dispatchWorkPlan } from '../../api/workPlan'

export default {
  name: 'WorkPlanPage',
  components: { ListPagination },
  data() {
    return {
      query: { planCode: '', planState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      detailVisible: false, detail: {}
    }
  },
  created() { this.load() },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    fmtDate(v) { return v ? String(v).substring(0, 10) : '' },
    fmtDateTime(v) {
      if (!v) return ''
      const s = String(v).replace('T', ' ')
      return s.length >= 16 ? s.substring(0, 16) : s
    },
    load() {
      this.loading = true
      listWorkPlan({
        currentPage: this.page, pageSize: this.pageSize,
        planCode: this.query.planCode, planState: this.query.planState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    viewRow(id) {
      return getWorkPlan(id).then(res => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    doPrint() {
      const el = document.getElementById('work-plan-print')
      if (!el) return
      const w = window.open('', '_blank')
      w.document.write(
        '<!DOCTYPE html><html><head><meta charset="utf-8"/><title></title>' +
        '<style>' +
        '@page{margin:0}' +
        'body{font-family:"Microsoft YaHei",SimSun,sans-serif;font-size:12px;color:#000;margin:0;padding:12mm}' +
        '.wp-title{text-align:center;margin:0 0 12px;font-size:18px}' +
        '.wp-meta{width:100%;border-collapse:collapse;margin-bottom:10px}' +
        '.wp-meta td{padding:4px 6px;border:1px solid #333;vertical-align:top}' +
        '.wp-lines{width:100%;border-collapse:collapse}' +
        '.wp-lines th,.wp-lines td{border:1px solid #333;padding:4px 6px}' +
        '.wp-lines th{background:#f2f2f2;font-weight:600}' +
        '.c{text-align:center}.r{text-align:right}' +
        '.wp-remark{margin-top:10px}.wp-sign{margin-top:24px;display:flex;justify-content:space-between}' +
        '</style></head><body>' + el.innerHTML + '</body></html>'
      )
      w.document.close()
      w.focus()
      setTimeout(() => { w.print() }, 200)
    },
    dispatchRow(id) {
      getWorkPlan(id).then(res => {
        const plan = res.data || {}
        const n = (plan.lineList || []).length
        this.$confirm(
          '确认下发「' + (plan.planCode || '') + '」？共 ' + n + ' 道工序任务。下发后可打印派工单。',
          '下发作业计划',
          { type: 'warning' }
        ).then(() => {
          dispatchWorkPlan(id).then(() => {
            this.$message.success('已下发')
            this.load()
            this.$confirm('是否立即打印派工单？', '打印', { type: 'info' }).then(() => {
              this.viewRow(id).then(() => this.$nextTick(() => this.doPrint()))
            }).catch(() => {})
          })
        }).catch(() => {})
      })
    },
    dispatchFromDetail() {
      if (!this.detail.planId) return
      this.dispatchRow(this.detail.planId)
    },
    deleteRow(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteWorkPlan([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.wp-print .wp-title { text-align: center; margin: 0 0 12px; font-size: 18px; }
.wp-meta { width: 100%; border-collapse: collapse; margin-bottom: 10px; font-size: 13px; }
.wp-meta td { padding: 4px 6px; border: 1px solid #dcdfe6; }
.wp-lines { width: 100%; border-collapse: collapse; font-size: 12px; }
.wp-lines th, .wp-lines td { border: 1px solid #dcdfe6; padding: 4px 6px; }
.wp-lines th { background: #f5f7fa; }
.wp-lines .c { text-align: center; }
.wp-lines .r { text-align: right; }
.wp-remark { margin-top: 10px; }
.wp-sign { margin-top: 20px; display: flex; justify-content: space-between; font-size: 13px; }
</style>
